const actions = {
    SPL_DASHBOARD_DATA_BEGIN: 'SPL_DASHBOARD_DATA_BEGIN',
    SPL_DASHBOARD_DATA_SUCCESS: 'SPL_DASHBOARD_DATA_SUCCESS',
    SPL_DASHBOARD_DATA_ERR: 'SPL_DASHBOARD_DATA_ERR',

    getSplDashboardDataBegin: () => {
        return {
            type: actions.SPL_DASHBOARD_DATA_BEGIN,
        };
    },

    getSplDashboardDataSuccess: (data) => {
        return {
            type: actions.SPL_DASHBOARD_DATA_SUCCESS,
            data,
        };
    },

    getSplDashboardDataErr: (err) => {
        return {
            type: actions.SPL_DASHBOARD_DATA_ERR,
            err,
        };
    },
};

export default actions;
